<template>
  <div class="tw-flex tw-items-center tw-justify-center tw-relative">
    <button
      v-for="item in props.data"
      :key="item?.id"
      class="tw-items-center tw-justify-center tw-pt-0 tw-flex tw-bg-transparent tw-relative"
      @click="onClickItem(item?.id)"
      @mouseover="idHover = item?.id"
      @mouseleave="idHover = -1"
    >
      <div
        v-if="idHover === item.id"
        class="tw-absolute tw-top-[-60px] tw-h-[50px] tw-flex tw-items-end tw-justify-center tw-min-w-[130px]"
      >
        <p
          :class="[
            activeComponent > item.id ? 'tw-bg-[#D9EDE2]' : 'tw-bg-white',
          ]"
          class="tw-text-[#01893D] tw-text-[11px] tw-font-medium tw-leading-[130%] tw-mb-[0px] tw-px-[5px] tw-py-[3px] tw-rounded-[4px] tw-text-center"
        >
          {{ item?.title }}
        </p>
      </div>
      <div
        v-if="item.statusPage === statusPage.CallApi"
        class="tw-h-[32px] tw-w-[32px] tw-justify-center tw-flex tw-items-center"
      >
        <!-- eslint-disable vue/no-unused-refs -->
        <LottieAnimation
          ref="anim"
          :animation-data="ProgressAnimation"
          :auto-play="true"
          :loop="true"
        />
      </div>

      <div v-else>
        <div
          v-if="item.statusPage === statusPage.Error"
          class="tw-h-[26px] tw-w-[26px] tw-justify-center tw-flex tw-items-center tw-ml-[3px] tw-mr-[3px]"
        >
          <!-- eslint-disable vue/no-unused-refs -->
          <LottieAnimation
            ref="anim"
            :animation-data="ErrorAnimation"
            :auto-play="true"
            :loop="false"
          />
        </div>

        <div
          v-else-if="item.statusPage === statusPage.Success"
          class="tw-h-[28px] tw-w-[28px] tw-justify-center tw-flex tw-items-center"
        >
          <!-- eslint-disable vue/no-unused-refs -->
          <LottieAnimation
            ref="anim"
            :animation-data="SuccessAnimation"
            :auto-play="true"
            :loop="false"
          />
        </div>
      </div>
      <div
        v-if="item.statusPage === statusPage.Updating"
        class="tw-h-[13.65px] tw-w-[13.65px] tw-m-[9.18px] tw-bg-[#DBDBDB] tw-rounded-full"
      />
      <div
        v-if="item.statusPage === statusPage.NotChange"
        class="tw-h-[13.65px] tw-w-[13.65px] tw-m-[9.18px] tw-bg-[#FFFFFF] tw-rounded-full"
      />
    </button>
  </div>
</template>

<script setup lang="ts">
import { PropType, ref, watch } from "vue";
import SuccessAnimation from "../../assets/animation/success.json";
import ErrorAnimation from "../../assets/animation/error.json";
import ProgressAnimation from "../../assets/animation/progress_light.json";
import { LottieAnimation } from "lottie-web-vue";
import { statusPage } from "@/utils/constants";
const props = defineProps({
  data: {
    type: Array as PropType<
      {
        title: string;
        id: number;
        statusPage: string;
        dataError: [];
      }[]
    >,
    required: true,
  },
  activeComponentId: {
    type: Number,
    required: true,
  },
});

const idHover = ref(-1);
const activeComponent = ref(props.activeComponentId);

const emit = defineEmits(["on:navigateItem"]);

watch(
  () => props.activeComponentId,
  (value) => {
    activeComponent.value = value;
  },
  { deep: true },
);

const onClickItem = (id: number) => {
  emit("on:navigateItem", id);
  idHover.value = -1;
};
</script>
